// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeleteRecurringTaskDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-deleterecurringtaskdialogcontainer" */ "./DeleteRecurringTaskDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteRecurringTaskDialogContainer
        };
    });
export const LazyDeleteRecurringTaskDialogContainer = /*#__PURE__*/ lazy(DeleteRecurringTaskDialogContainerLazyLoader);
